import { FiTrash2 } from "react-icons/fi";
import "./style.scss";
import { Link } from "react-router-dom";
function StudentCardTwo({ document, folder, removeDocument }: { document: any, folder: string, removeDocument: any }) {
  const BASE_URL = process.env.REACT_APP_API_PROTOCOL + "://" + process.env.REACT_APP_API_HOST
  const fileUrl = `${BASE_URL}/uploads/documents/${folder}/${document?.filename}`
  return (
    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
      <div className="students_card_tow" title={document?.label}>
        <div className="d-flex justify-content-between">
          <div className="name" >{document?.label?.length > 18 ? document?.label?.substring(0, 18) + "..." : document?.label}</div>
          <span className="text-danger" style={{ cursor: "pointer" }} onClick={() => removeDocument(document?._id)}><FiTrash2 /></span>
        </div>
        <div className="image">
          {document?.mimetype?.includes("image") ? <Link to={fileUrl} target="_blank"> <img src={fileUrl} alt="" /> </Link> : <div className="d-flex justify-content-center align-items-center">
            <Link to={fileUrl} target="_blank" className="button text-decoration-none mt-4" role="button">View</Link>
          </div>}
        </div>
      </div>
    </div>
  );
}

export default StudentCardTwo;
